"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILIconSelector = void 0;
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var enums_1 = require("../../shared/enums");
var icon_1 = require("../icon/icon");
function ILIconSelector(_a) {
    var disabled = _a.disabled, _b = _a.component, component = _b === void 0 ? 'div' : _b, parentComponent = _a.parentComponent, sx = _a.sx, defaultOption = _a.defaultOption, options = _a.options, className = _a.className, popoverProps = _a.popoverProps, onSelect = _a.onSelect, _c = _a.column, column = _c === void 0 ? 4 : _c;
    var _d = react_1.default.useState(null), anchorEl = _d[0], setAnchorEl = _d[1];
    var _e = react_1.default.useState(defaultOption || (options === null || options === void 0 ? void 0 : options[0])), selectedIcon = _e[0], setSelectedIcon = _e[1];
    var classes = 'il-icon-selector ' + className;
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var open = Boolean(anchorEl);
    var id = open ? 'icon-popover' : undefined;
    return (react_1.default.createElement(material_1.Box, { className: classes, component: parentComponent },
        react_1.default.createElement(material_1.Button, { "aria-describedby": id, "aria-label": "icon-selector", variant: "outlined", onClick: handleClick, disabled: disabled, sx: __assign({ p: '0.3125rem', width: '3.5rem', height: '3.5rem', position: 'relative' }, sx) },
            !disabled && (react_1.default.createElement(icon_1.Icon, { sx: {
                    position: 'absolute',
                    bottom: '1.375rem',
                    right: '-1.275rem',
                    borderWidth: '0.0625rem',
                    borderRadius: '50%',
                    borderColor: 'primary.main',
                    borderStyle: 'solid',
                    p: '0.5rem',
                    transform: 'scale(0.35)',
                    bgcolor: 'background.paper',
                    color: 'text.primary',
                }, icon: enums_1.IconEnum.LIGHT_PENCIL, size: enums_1.IconSizeEnum.LARGE })),
            selectedIcon && react_1.default.createElement(icon_1.Icon, { icon: selectedIcon, size: enums_1.IconSizeEnum.LARGE })),
        react_1.default.createElement(material_1.Popover, __assign({ id: id, open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                vertical: 'top',
                horizontal: 'left',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
            } }, popoverProps),
            react_1.default.createElement(material_1.Box, { sx: {
                    p: '0.25rem',
                    display: 'grid',
                    gap: '0.125rem',
                    gridTemplateColumns: "repeat(".concat(column, ", 1fr)"),
                }, component: component }, options.map(function (ic) { return (react_1.default.createElement(material_1.IconButton, { key: ic, sx: __assign(__assign({ borderRadius: '0.5rem', px: '0.3125rem', py: '0.325rem' }, (ic === selectedIcon && { backgroundColor: 'action.selected' })), { color: 'primary.main' }), onClick: function () {
                    setSelectedIcon(ic);
                    onSelect(ic);
                    handleClose();
                } },
                react_1.default.createElement(icon_1.Icon, { sx: { display: 'flex', alignItems: 'center', justifyContent: 'center' }, icon: ic, size: enums_1.IconSizeEnum.XXSMALL }))); })))));
}
exports.ILIconSelector = ILIconSelector;
